import { createClient, type SupabaseClient } from '@supabase/supabase-js';
import { env } from './env';
import type { Database } from '@/types/database.generated';
import { createGuardedAuthStorage } from '@/lib/authStorage';
import { AUTH_STORAGE_KEY } from '@/lib/performSignOut';
import { fetchWithLogoutTimeout } from '@/lib/authFetch';

/**
 * Browser Supabase client. Uses the publishable/anon key — RLS enforces every
 * read/write. Never instantiate the service-role client in the web app.
 * Sessions persist in localStorage and are auto-refreshed.
 */
export const supabase: SupabaseClient<Database> = createClient<Database>(
  env.VITE_SUPABASE_URL,
  env.VITE_SUPABASE_ANON_KEY,
  {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true,
      flowType: 'pkce',
      storageKey: AUTH_STORAGE_KEY,
      storage: createGuardedAuthStorage(),
    },
    global: {
      headers: {
        'x-application-name': 'clinio-web',
      },
      fetch: fetchWithLogoutTimeout,
    },
  },
);

export type ClinioSupabaseClient = SupabaseClient<Database>;
